var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
//   document.querySelector("#dynamic1").dynamicData = [
//       {product_url: "https://www.insiderstore.com.br/products/tech-t-shirt"},
//       {product_url: "https://www.insiderstore.com.br/products/tech-t-shirt-feminina"}
// ]
// document.querySelector("#dynamic1").dataset.timestamp = 1234
if (!customElements.get("dynamic-collection-slider"))
    customElements.define("dynamic-collection-slider", class DynamicCollectionSlider extends HTMLElement {
        static get observedAttributes() {
            return ["data-timestamp"];
        }
        validateJSON(schema, data) {
            if (schema.type) {
                if (schema.type === "object" && typeof data !== "object")
                    return false;
                if (schema.type === "array" && !Array.isArray(data))
                    return false;
                if (schema.type === "string" && typeof data !== "string")
                    return false;
                if (schema.type === "number" && typeof data !== "number")
                    return false;
                if (schema.type === "boolean" && typeof data !== "boolean")
                    return false;
            }
            if (schema.required) {
                for (let field of schema.required) {
                    if (!(field in data))
                        return false;
                }
            }
            if (schema.properties) {
                for (let key in schema.properties) {
                    if (data[key] !== undefined)
                        if (!this.validateJSON(schema.properties[key], data[key]))
                            return false;
                }
            }
            return true;
        }
        /**
         * Deve ter um attributo de status, onde se o marcador de carregamento dinâmico estiver ativo, ele deve sempre iniciar como pending.
         * Caso já tenha e o fallback é quem deve ser carregado, seu status já vai direto para ready.
         * Caso o changeCallback seja disparado com dados atualizados ele deve verificar se o status é pending e, em caso afirmativo, mudar para ready e executar o init com os dados atualizados.
         * Devemos ter um timeout no init, para quando tivermos o carregamento dinâmico caso esse timeout seja atingido, o status altera para fallbackReady, excecuta as mudanças e dispara um error para o logger.
         *
         */
        constructor() {
            super();
            this.checkpoints = [];
            this.REQUEST_TIMEOUT_MS = 2000;
            this.DYNAMIC_WAITING_TIMEOUT = 5000;
            this.COLLECTION_LIST_MALE = [];
            this.COLLECTION_LIST_FEMALE = [];
            this.maxProducts = 0;
            this.localType = "section";
            this.toLogger = false;
            this.status = "notStarted";
            this.log = Object.assign((...args) => {
                if (this.toLogger)
                    console.log("%c[DEBUG]", "color:red;", `[DynamicCollectionId: ${this.id}]`, ...args);
            }, {
                error: (message, ...args) => {
                    console.error(`[DynamicCollectionSlider] ${message}`, `[Id: ${this.id}]`, {
                        status: this.status,
                        dynamicData: this.dynamicData,
                        checkpoints: this.checkpoints,
                        useDynamicRecommender: this.useDynamicRecommender
                    }, ...args);
                },
                warn: (message, ...args) => {
                    console.warn(`[DynamicCollectionSlider] ${message}`, `[Id: ${this.id}]`, {
                        status: this.status,
                        dynamicData: this.dynamicData,
                        checkpoints: this.checkpoints,
                        useDynamicRecommender: this.useDynamicRecommender
                    }, ...args);
                },
                info: (...args) => {
                    if (this.toLogger)
                        console.info("%c[INFO]", "color:blue;", `[DynamicCollectionId: ${this.id}]`, ...args);
                }
            });
        }
        connectedCallback() {
            //TODO: Rever essa lógica de inicialização
            if (this.dataset.placement === "cart-drawer-upsell") {
                const hasItems = (this.getAttribute('data-cart-has-items')) ? Number(this.getAttribute('data-cart-has-items')) : 0;
                if (hasItems == 0) {
                    return;
                }
            }
            this.settingProperties();
            this.addCheckpoint("Start");
            this.addListeners();
            this.initOrchestrator();
        }
        settingProperties() {
            // this.toLogger = sessionStorage.getItem('insider:debug:dynamic-collection-slider') === 'true' ? true : false;
            this.toLogger = false;
            this.maxProducts = parseInt(this.getAttribute("data-max-products")) || 0;
            this.localType = this.getAttribute("data-local-type") || "section";
            this.MCelements = {
                options: document.querySelectorAll(`.${this.dataset.classSection} .do-select_collection`),
                collections: document.querySelectorAll(`.${this.dataset.classSection} .do-collection__item`),
            };
            this.useDynamicRecommender = this.getAttribute("data-use-dynamic-recommender") === "true";
            this.COLLECTIONS_LIST = this.getAttribute("data-collections-fallback") || undefined;
            if (this.COLLECTIONS_LIST && this.COLLECTIONS_LIST.includes(";")) {
                const COLLECTIONS_LIST_SPLIT = this.COLLECTIONS_LIST.split(";");
                this.COLLECTION_LIST_MALE = COLLECTIONS_LIST_SPLIT[0].split(",");
                this.COLLECTION_LIST_FEMALE = COLLECTIONS_LIST_SPLIT[1].split(",");
            }
            else {
                this.COLLECTION_LIST_MALE = this.COLLECTIONS_LIST.split(",");
                this.COLLECTION_LIST_FEMALE = this.COLLECTIONS_LIST.split(",");
            }
            if (this.useDynamicRecommender)
                this.status = "pending";
        }
        initOrchestrator() {
            return __awaiter(this, void 0, void 0, function* () {
                this.addCheckpoint("initOrchestrator");
                if (!["fallbackReady", "ready", "forceNoRender"].includes(this.status)) {
                    if (this.useDynamicRecommender) {
                        yield this.delay(this.DYNAMIC_WAITING_TIMEOUT);
                        this.addCheckpoint("after delay");
                        const dynamicDataIsValid = this.validateJSON({
                            "type": "object",
                            "properties": {
                                "gender_collections": {
                                    "type": "boolean"
                                },
                                "product_handles": {
                                    "type": "array",
                                    "items": {}
                                },
                                "product_handles_female": {
                                    "type": "array",
                                    "items": {}
                                },
                                "product_handles_male": {
                                    "type": "array",
                                    "items": {}
                                }
                            }
                        }, this.dynamicData);
                        if (this.status === "forceNoRender")
                            return;
                        // useDynamicRecommender está replicado pois é necessário re-verificar seu valor após o delay
                        if (!dynamicDataIsValid && this.useDynamicRecommender) {
                            this.status = "fallbackReady";
                            this.useDynamicRecommender = false;
                            this.log.error("Dynamic data not found or invalid, switching to fallback");
                        }
                        if (!this.useDynamicRecommender) {
                            this.status = "fallbackReady";
                            this.log.info("useDynamic is forced false, switching to fallback");
                        }
                    }
                    else {
                        this.log("[initOrchestrator]", "fallback default choice");
                        this.status = "ready";
                    }
                    this.init();
                }
            });
        }
        delay(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        }
        applyMaxProducts(list) {
            if (!Array.isArray(list))
                return list;
            if (!this.maxProducts || this.maxProducts <= 0)
                return list;
            return list.slice(0, this.maxProducts);
        }
        attributeChangedCallback(name, oldValue, newValue) {
            if (!!oldValue) {
                if (name === "data-timestamp") {
                    this.log("[attributeChangedCallback]", " fired by:", this.dataset.timestamp.split("-")[0]);
                    if (this.status === 'forceNoRender') {
                        this.useDynamicRecommender = false;
                        this.log.info("Update fired force no render, stopping execution");
                    }
                    if ((this.status === 'pending' && this.dynamicData)) {
                        this.log.info("Update fired with Dynamic data, re-initializing");
                        this.init();
                    }
                    if (this.status === "pendingForceFallback") {
                        this.useDynamicRecommender = false;
                        this.log.info("Update fired forced without Dynamic data, switching to fallback");
                        this.init();
                    }
                    if (this.status === 'pending' && !this.dynamicData) {
                        this.useDynamicRecommender = false;
                        this.log.error("Update fired without Dynamic data, switching to fallback");
                        this.init();
                    }
                }
            }
        }
        addCheckpoint(label) {
            const time = performance.now();
            this.checkpoints.push({ label, time });
            // console.log(`[CHECKPOINT][${this.localType}][${label}]: ${time} ms`);
        }
        addListeners() {
            this.addCheckpoint("addListeners");
            this.MCelements.options.forEach((option) => {
                option.addEventListener("click", this.handleOptionChange.bind(this));
            });
        }
        init() {
            this.addCheckpoint("start init");
            this.handleData();
        }
        handleOptionChange(event) {
            this.MCelements.options.forEach((option) => {
                option.classList.remove("active");
            });
            let selection = Array.from(event.target.classList).find((elements) => elements === "do-select_collection") == undefined
                ? event.target.parentElement
                : event.target;
            selection.classList.add("active");
            let value = selection.dataset.index || "collection-0";
            this.MCelements.collections.forEach((collection) => {
                collection.classList.remove("active");
                if (collection.dataset.index == value) {
                    Array.from(collection.classList).find((item) => item == "active") == undefined
                        ? collection.classList.add("active")
                        : collection.classList.remove("active");
                }
            });
        }
        handleData() {
            return __awaiter(this, void 0, void 0, function* () {
                let products;
                let isCollectionsOfGenres;
                let isAUniqueCollection;
                if (this.useDynamicRecommender) {
                    this.addCheckpoint("start handleData");
                    this.log("start handleData useDynamicRecommender");
                    // products = this.dynamicData.slice(0, this.maxProducts || this.dynamicData.length);
                    if (this.dynamicData.gender_collections) {
                        isCollectionsOfGenres = true;
                        isAUniqueCollection = false;
                        products = {
                            male: this.applyMaxProducts(this.dynamicData.product_handles_male || []),
                            female: this.applyMaxProducts(this.dynamicData.product_handles_female || []),
                        };
                    }
                    else {
                        isCollectionsOfGenres = false;
                        isAUniqueCollection = true;
                        products = this.applyMaxProducts(this.dynamicData.product_handles || []);
                    }
                }
                else {
                    products = {
                        male: this.applyMaxProducts(this.COLLECTION_LIST_MALE.map((product_url) => ({
                            product_url: `https://www.insiderstore.com.br/products/${product_url}`,
                        }))),
                        female: this.applyMaxProducts(this.COLLECTION_LIST_FEMALE.map((product_url) => ({
                            product_url: `https://www.insiderstore.com.br/products/${product_url}`,
                        }))),
                    };
                    isCollectionsOfGenres = !!this.COLLECTION_LIST_FEMALE;
                    isAUniqueCollection = !this.COLLECTION_LIST_FEMALE;
                }
                if (isAUniqueCollection && Array.isArray(products)) {
                    products = this.applyMaxProducts(products);
                }
                const hasProductsInUniqueCollection = isAUniqueCollection && products.length > 0;
                const hasProductsInCollectionsOfGenres = isCollectionsOfGenres && products.female.length > 0 && products.male.length > 0;
                if (hasProductsInUniqueCollection || hasProductsInCollectionsOfGenres) {
                    const HTMLproducts = yield this.handleProduct(products, isAUniqueCollection, isCollectionsOfGenres).then((response) => __awaiter(this, void 0, void 0, function* () {
                        if (isCollectionsOfGenres)
                            return {
                                male: yield response.male,
                                female: yield response.female,
                            };
                        return response;
                    }));
                    this.addCheckpoint("call render html");
                    if (isCollectionsOfGenres && this.dataset.template !== "upsellCard") {
                        const collection_section = document.querySelector(`.${this.dataset.classSection} .list__collection_selection`);
                        collection_section.style.display = "flex";
                    }
                    this.renderHTML(HTMLproducts, isAUniqueCollection, isCollectionsOfGenres);
                }
                else {
                    // console.log(`[Dynamic Offer][CHECKPOINT][${this.localType}]`, JSON.stringify(this.checkpoints));
                    this.enableGlide(false);
                }
            });
        }
        handleProduct(listUrlProducts, isAUniqueCollection, isCollectionsOfGenres) {
            return __awaiter(this, void 0, void 0, function* () {
                this.addCheckpoint("start handleProduct");
                const template = this.dataset.template;
                // AXULIAR FUNCTIONS
                function getfetch({ product_url }) {
                    return fetch(`${product_url}${product_url.includes("?") ? "&" : "?"}view=${template}`).then((response) => response.text());
                }
                function createFetchList(urls) {
                    return urls.map(getfetch);
                }
                function processFetches(fetches) {
                    return __awaiter(this, void 0, void 0, function* () {
                        const responses = yield Promise.all(fetches.map((promise) => promise.then((HTMLProduct) => HTMLProduct)));
                        return responses;
                    });
                }
                // PROCESSING VARIABLES FUNCTIONS
                const listFetch = yield (() => __awaiter(this, void 0, void 0, function* () {
                    this.addCheckpoint("start handleProduct");
                    if (isAUniqueCollection)
                        return createFetchList(listUrlProducts);
                    if (isCollectionsOfGenres)
                        return {
                            male: createFetchList(listUrlProducts.male || []),
                            female: createFetchList(listUrlProducts.female || []),
                        };
                }))();
                const listFetchProcessed = (() => {
                    if (isCollectionsOfGenres)
                        return new Promise((resolve) => resolve({
                            male: processFetches(listFetch.male),
                            female: processFetches(listFetch.female),
                        }));
                    return processFetches(listFetch);
                })();
                listFetchProcessed
                    .then((HTMLProduct) => __awaiter(this, void 0, void 0, function* () {
                    if (isCollectionsOfGenres) {
                        return yield Promise.all([HTMLProduct.male, HTMLProduct.female]).then(([maleData, femaleData]) => {
                            return {
                                male: maleData,
                                female: femaleData,
                            };
                        });
                    }
                    return HTMLProduct;
                }))
                    .catch((error) => {
                    // console.log("Erro ao processar fetches:", error);
                    // console.log(`[Dynamic Offer][CHECKPOINT][${this.localType}]`, JSON.stringify(this.checkpoints));
                });
                return listFetchProcessed;
            });
        }
        renderHTML(HTMLproducts, isAUniqueCollection, isCollectionsOfGenres) {
            this.addCheckpoint("Start render HTML");
            this.log("[DEBUG][Statsig][] render");
            let checkDOMStatusIntervalCounter = 0;
            const checkDOMStatusInterval = setInterval(() => {
                this.addCheckpoint("checkDOMStatusInterval Loop " + checkDOMStatusIntervalCounter);
                checkDOMStatusIntervalCounter++;
                // if (document.readyState === "complete") {
                if (typeof Glide === "function") {
                    const template = this.dataset.template;
                    if (isCollectionsOfGenres) {
                        const maleListItemClass = (() => {
                            if (template === "upsellCard")
                                return `.${this.dataset.classSection} .${this.dataset.classContainer}`;
                            return `.${this.dataset.classSection} .do-collection__item[data-index="collection-0"] .${this.dataset.classContainer}`;
                        })();
                        const maleListItems = this.querySelector(maleListItemClass);
                        for (let i = 0; i < HTMLproducts.male.length; i++) {
                            const product = new DOMParser().parseFromString(`<li class="glide__slide">${HTMLproducts.male[i]}</li>`, "text/html");
                            if (HTMLproducts.male[i].indexOf("product-card-snippet") > 0) {
                                const card = product.querySelector(`.glide__slide`);
                                maleListItems.append(card);
                            }
                        }
                        const femaleListItemClass = (() => {
                            if (template === "upsellCard")
                                return `.${this.dataset.classSection} .${this.dataset.classContainer}`;
                            return `.${this.dataset.classSection} .do-collection__item[data-index="collection-1"] .${this.dataset.classContainer}`;
                        })();
                        const femaleListItems = this.querySelector(femaleListItemClass);
                        for (let i = 0; i < HTMLproducts.female.length; i++) {
                            const product = new DOMParser().parseFromString(`<li class="glide__slide">${HTMLproducts.female[i]}</li>`, "text/html");
                            if (HTMLproducts.female[i].indexOf("product-card-snippet") > 0) {
                                const card = product.querySelector(`.glide__slide`);
                                femaleListItems.append(card);
                            }
                        }
                    }
                    if (isAUniqueCollection) {
                        const listItemClass = (() => {
                            if (template === "upsellCard")
                                return `.${this.dataset.classSection} .${this.dataset.classContainer}`;
                            return `.${this.dataset.classSection} .do-collection__item[data-index="collection-0"] .${this.dataset.classContainer}`;
                        })();
                        const headingElement = this.querySelector(".heading");
                        if (headingElement) {
                            headingElement.style.display = "block";
                        }
                        const listItems = this.querySelector(listItemClass);
                        if (listItems.children.length === 0) {
                            for (let i = 0; i < HTMLproducts.length; i++) {
                                const product = new DOMParser().parseFromString(`<li class="glide__slide" data-i="${i}">${HTMLproducts[i]}</li>`, "text/html");
                                if (HTMLproducts[i].indexOf("product-card-snippet") > 0) {
                                    const card = product.querySelector(`.glide__slide`);
                                    this.log("[DEBUG][Statsig][test-collection-slider-v1] listItems", listItems);
                                    listItems.append(card);
                                }
                            }
                        }
                    }
                    if (this.dataset.glide === "true") {
                        this.enableGlide(true, isAUniqueCollection, isCollectionsOfGenres);
                    }
                    this.classList.add("active");
                    clearInterval(checkDOMStatusInterval);
                }
            }, 100);
        }
        enableGlide(useinsiderCollectionLoaded = true, isAUniqueCollection = false, isCollectionsOfGenres = false) {
            this.addCheckpoint("enable glide");
            const elementGlide = useinsiderCollectionLoaded ? "main_collection" : "reserve_collection";
            const elementHidden = !useinsiderCollectionLoaded ? "main_collection" : "reserve_collection";
            const toHiddenClasses = (() => {
                if (this.dataset.template === "upsellCard") {
                    return [
                        `.${this.dataset.classSection} .loading-smart-recommender`,
                        `.${this.dataset.classSection} .${elementHidden}`,
                    ];
                }
                return [
                    `.${this.dataset.classSection} .do-collection__item[data-index="collection-0"] .loading-smart-recommender`,
                    `.${this.dataset.classSection} .do-collection__item[data-index="collection-1"] .loading-smart-recommender`,
                    `.${this.dataset.classSection} .do-collection__item[data-index="collection-0"] .${elementHidden}`,
                    `.${this.dataset.classSection} .do-collection__item[data-index="collection-1"] .${elementHidden}`,
                ];
            })();
            toHiddenClasses.forEach((className) => {
                const toHidden = this.querySelector(className);
                if (toHidden)
                    toHidden.style.display = "none";
            });
            const glideRecommenders = {
                default: this.querySelector(`.${this.dataset.classSection} .${elementGlide}`),
                collection0: this.querySelector(`.${this.dataset.classSection} .do-collection__item[data-index="collection-0"] .${elementGlide}`),
                collection1: this.querySelector(`.${this.dataset.classSection} .do-collection__item[data-index="collection-1"] .${elementGlide}`),
            };
            const _enableGlide = (glideElement) => {
                glideElement.classList.add("active");
                if (typeof glideElement.glideEnable === "function")
                    glideElement.glideEnable();
                if (this.dataset.glideControl === "true" && useinsiderCollectionLoaded) {
                    glideElement.glideSetControlls();
                }
                glideElement.init();
            };
            if (this.dataset.template === "upsellCard") {
                _enableGlide(glideRecommenders.default);
                this.addCheckpoint("glide init default");
            }
            else {
                _enableGlide(glideRecommenders.collection0);
                this.addCheckpoint("glide init collection0");
                _enableGlide(glideRecommenders.collection1);
                this.addCheckpoint("glide init collection1");
            }
            this.addCheckpoint("glide init");
            this.log(`[DEBUG][Dynamic Offer][CHECKPOINT][${this.localType}]`, JSON.stringify(this.checkpoints));
        }
    });
